<template lang="pug">
    div.meditationOuter
        div.meditation(:class="{mobile: isMobile, blur: blur}")
            div
                div.meditationImage(@click="play")

                    // Meditation Cover Image
                    img(v-lazy="coverImage")


                    // Mobile version Play button
                    div.mobilePlayButton(v-if="isMobile")
                        v-btn.button(
                            color="white"
                            flat
                            icon
                            @click="play"
                        )
                            v-icon.icon play_arrow


                    div.hoverContent.text-xs-center(v-if="!isMobile")
                        div

                            // Meditation Title on hover
                            div
                                p.meditationTitle(v-line-clamp:22="2") {{ item.title }}

                            div

                                // Play button on hover
                                v-btn.button(
                                    color="white"
                                    flat
                                    icon
                                    @click="play"
                                )
                                    v-icon.icon play_arrow
                div.content
                    div.contentInner

                        // Meditation Title
                        div(@click="play")
                            div.meditationTitle(v-line-clamp:22="2")
                                span {{ item.title }}

                        // Meditation Duration
                        div.meditationDuration(v-if="item.duration")
                            div {{ item.duration | timeCode }}

                    // Meditation Description on hover
                    div.hoverContent(v-if="!isMobile")
                        p.description(v-line-clamp:15="6") {{ item.description }}

            div

                // Horizontal line
                div.px-2
                    separator-component


                div.contentFooter

                    // Instructor Information
                    instructor(v-if="item.instructor_fullName" :fullName="item.instructor_fullName" :avatar="item.instructor_avatar")
</template>

<script>
    import VueTypes from 'vue-types';
    import Separator from '../../../../../components/Separator';
    import Share from '../../../../../components/Share';
    import Status from '../../../../../components/Status';
    import formattedDateTime from '~filters/FormattedDateTime';
    import formattedDateTimeWithCheckIn from '~filters/FormattedDateTimeWithCheckIn';
    import timeCode from '~filters/timeCode';
    import { mapActions } from 'vuex';
    import Instructor from './Instructor';
    import dayjs from 'dayjs';

    export default {
        components: {
            Instructor,
            StatusComponent: Status,
            SeparatorComponent: Separator,
            ShareComponent: Share
        },
        filters: {
            formattedDateTime,
            timeCode,
            formattedDateTimeWithCheckIn
        },
        props: {
            item: VueTypes.object.def({}),
            duration: VueTypes.number.def(0),
            index: VueTypes.number.def(0),
            handlePlay: VueTypes.func.def(() => {})
        },
        data() {
            return {
                blur: false
            };
        },
        computed: {
            /**
             * Cover Image.
             * @returns {string}
             */
            coverImage() {
                if (this.item.poster) return this.item.poster;
                return `https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditations-cover-images/buildingImage.png`;
            },

            /**
             * Check is Locked Meditation.
             * @returns {boolean}
             */
            lockedMeditation() {
                return false;
            },

            /**
             * Check screen resolution.
             * @returns {boolean}
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },

            /**
             * Show Join Meditation button.
             * @returns {boolean}
             */
            showJoinMeditation() {
                let currentDate = dayjs();
                let startedAt = dayjs(this.item.startedAt);
                let diffTime = startedAt.diff(currentDate, 'seconds');

                if (diffTime > 0 && diffTime <= 10 * 60) {
                    return true;
                } else if (diffTime >= -10 * 60 && diffTime < 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            ...mapActions('sessions', ['resetSession']),

            /**
             * Blur card toggle
             */
            setBlur(isActive) {
                this.blur = isActive;
            },

            /**
             * Play video
             */
            play() {
                this.handlePlay(this.item.id);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../../assets/style/_variables.styl'

    .meditationOuter
        position: relative
        box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);
        border-radius: 10px
        height: calc(100% - 16px)
        min-height: 270px
        transition: filter .3s

    .meditation
        background-color: $theme.info
        margin-bottom: 16px
        height: 100%
        justify-content: space-between
        display: flex
        flex-direction: column
        border-radius: 10px
        overflow: hidden

        &.disabled
            background: rgba(2, 35, 65, .4)

            .meditationImage img
                opacity: 0.6

        &:not(.mobile) > div:hover

            .meditationImage img
                opacity: 0.6

            .hoverContent
                opacity: 1
                top: 0

            .content .contentInner
                opacity: 0

    .desktopPlayButton
        position: absolute
        width: 40px
        height: 40px
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        border: 1px solid #fff
        border-radius: 50%
        color: white
        text-align: center

        .icon
            color: white
            line-height: 40px
            font-size: 27px

    .mobilePlayButton
        position: absolute
        z-index: 2
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        background-color: rgba(0, 0, 0, 0.3)
        border-radius: 50%

        .button
            width: 40px
            height: 40px
            opacity: 1

        .icon
            font-size: 40px

    .content
        position: relative
        padding: 34px 8px 0
        font-size: 12px

    .description
        font-style: italic

    .description
    .meditationTitle
        word-break: normal !important

    .contentFooter
        padding: 0 8px 8px
        display: flex
        justify-content: space-between
        align-items: center

    .meditationTitle
        font-size: 22px
        line-height: 24px
        font-weight: 300
        margin-bottom: 5px

    .businesses
        margin-top: 10px
        margin-bottom: 15px
        text-overflow: ellipsis

        overflow: hidden
        white-space: nowrap

    .meditationImage
        position: relative
        overflow: hidden
        height: 150px

        img
            transition: opacity 0.3s
            min-width: 100%
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
            z-index: 1

    .meditationDuration
        font-size: 12px
        display: flex
        align-items: center

    .hoverContent
        position: absolute
        z-index: 2
        top: 20px
        left: 0
        width: 100%
        height: 100%
        padding: 8px
        opacity: 0
        transition: 0.3s

        & > div
            display: flex
            height: 100%
            flex-direction: column
            align-items: center
            justify-content: center

        .businesses
            margin: 0

        .icon
            color: $theme.white
            font-size: 34px

        button
            border-radius: 50%
            border: 1px solid #fff
            width: 40px
            height: 40px

    .statusItem
        position: absolute
        z-index: 2
        left: 5px
        top: 10px

        .wide
            width: 110px;

    .share
        position: absolute
        bottom: 6px
        right: 6px
        z-index: 2

    .blur
        filter: blur(3px)
</style>
